/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Disabled_ToastInputs */



/**
* | output |
* | --- |
* | "Live captioning disabled." |
*
* @param {Live_Caption_Disabled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_disabled_toast = /** @type {((inputs?: Live_Caption_Disabled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Disabled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titrage en direct désactivé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Untertitelung deaktiviert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli in tempo reale disabilitati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры в реальном времени отключены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos en directo desactivados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("实时字幕已关闭。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブ字幕は無効になっています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग अक्षम है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas ao vivo desativadas.")
	return /** @type {LocalizedString} */ ("Live captioning disabled.")
});